import { render, staticRenderFns } from "./tabMBLUICustomLayout.vue?vue&type=template&id=34089497&"
import script from "./tabMBLUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabMBLUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34089497')) {
      api.createRecord('34089497', component.options)
    } else {
      api.reload('34089497', component.options)
    }
    module.hot.accept("./tabMBLUICustomLayout.vue?vue&type=template&id=34089497&", function () {
      api.rerender('34089497', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabMBLUICustomLayout.vue"
export default component.exports